import { render, staticRenderFns } from "./ReportSKUDiscountItem.vue?vue&type=template&id=7d4aaf84&"
import script from "./ReportSKUDiscountItem.vue?vue&type=script&lang=js&"
export * from "./ReportSKUDiscountItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports